import { ApiRequestError } from "./api.js";

const AI_LIMIT_CODES = new Set(["ai_rate_limited", "ai_token_budget_exceeded"]);

/** Cooldown before re-enabling AI chat inputs after a tenant rate or token budget 429. */
export const AI_USAGE_LIMIT_COOLDOWN_MS = 60_000;

export function isAiUsageLimitError(e: unknown): e is ApiRequestError {
  return e instanceof ApiRequestError && e.status === 429 && AI_LIMIT_CODES.has(e.code);
}
